var map = {
	"./anthropic.png": 597,
	"./buld.jpg": 543,
	"./cohesity.png": 304,
	"./coursera.png": 73,
	"./deeplearning.png": 331,
	"./durvesh_danve.jpg": 521,
	"./google.png": 678,
	"./ijs.png": 951,
	"./mit-wpu.png": 418,
	"./project-aeronova.png": 800,
	"./project-cad.png": 654,
	"./project-neon-overdrive.png": 424,
	"./project-pokedex.png": 187,
	"./project-retro-workstation.png": 842,
	"./project-second-brain.png": 127,
	"./udemy.png": 453,
	"./veritas.png": 544,
	"./viit.png": 749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;